<script>
  import Loading from './Loading.svelte'
  import {
    selectedZipCodeStore as selectedZipCode
  } from '../stores'

  export let handleZipCodeChange
  let inputElement

  $: if (inputElement) {
    inputElement.focus()
  }
</script>

<style lang="scss">
  input {
    width: calc(100% - 30px);
    background-color: transparent;
    border: 0;
    display: block;
    border-radius: 50px;
    outline: 0;
    padding: 0;
    font-family: ICATextNy, arial, serif;
    font-size: 24px;
    letter-spacing: 3px;
    -moz-appearance: textfield;
    color: var(--color-black);
    text-align: center;

    @media only screen and (min-width: 320px) {
      line-height: 50px;
      text-align: left;
      padding: 0 var(--spacing);
    }
  }
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  label {
    color: var(--color-black);
    font-family: ICATextNy, arial, serif;
    font-size: 16px;
    white-space: nowrap;

    @media only screen and (min-width: 320px) {
      line-height: 50px;
    }

    @media (--for-tablet-portrait-up) {
      font-size: 18px;
    }
  }
  div {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 var(--spacing);
    padding: 0;
    border-radius: 50px;
    background-color: var(--color-white);

    @media only screen and (min-width: 320px) {
      flex-wrap: nowrap;
      flex: 0 1 100%;
      max-width: 550px;
      
      padding: 0 calc(var(--spacing) * 2);
    }

    @media (--for-tablet-portrait-up) {
      margin: 0 auto;
    }
  }
</style>

<div>
  <label for="zipcode">Ditt postnummer:</label>
  <input
    bind:this={inputElement}
    on:input={handleZipCodeChange}
    name="zipcode"
    id="zipcode"
    type="number"
    pattern="[0-9]*"
    maxlength="5"
    value={$selectedZipCode} />
  <Loading position="right" />
</div>
